<app-breadcrumb [master]="'Administracja'" [parentName]="'Hiperio'" [name]="'Wnioski o dostępy testowe'"></app-breadcrumb>
<div class="hiperio-test-access-form-list-container">

  <form (keyup.enter)="filter()" (submit)="filter()" #filtersForm="ngForm" class="hiperio-test-access-form-list-filters">
    <app-dict-partners
      [multiple]="false" [label]="'Partner'"
      class="hiperio-test-access-form-list-filter"
      [(ngModel)]="initialFilters.partner" name="partner"
    ></app-dict-partners>

    <app-dict-ofwcas
      [multiple]="false" label="OFWCA"
      class="hiperio-test-access-form-list-filter "
      [(ngModel)]="initialFilters.ofwca" name="ofwca"
    ></app-dict-ofwcas>


    <app-datepicker
      class="hiperio-test-access-form-list-filter"
      label="Data utworzenia od"
      placeholder="2000-01-01"
      [required]="false"
      [(ngModel)]="initialFilters.gte$createdAt" name="gte$createdAt"
    ></app-datepicker>

    <app-datepicker
      class="hiperio-test-access-form-list-filter"
      label="Data utworzenia do"
      placeholder="2000-01-01"
      [required]="false"
      [(ngModel)]="initialFilters.lte$createdAt" name="lte$createdAt"
    ></app-datepicker>

    <app-dict
      [multiple]="false" [dictType]="'hiperio_test_access_form_status'"
      [label]="'Status'" class="hiperio-test-access-form-list-filter"
      [(ngModel)]="initialFilters.status" name="status"
    ></app-dict>

    <app-dict-regionals
      [multiple]="false" label="Regionalny (majątek)"
      class="hiperio-test-access-form-list-filter"
      [(ngModel)]="initialFilters.assetsRegional" name="assetsRegional"
    ></app-dict-regionals>


  </form>

  <div class="hiperio-test-access-form-buttons">
    <button (click)="filter()" mat-raised-button color="primary"><mat-icon>search</mat-icon> <span> Szukaj</span></button>
    <button (click)="resetFilters()" mat-raised-button color="warn"><mat-icon>delete</mat-icon> <span> Resetuj filtry</span></button>
  </div>

    <table mat-table [dataSource]="jobs" >

      <ng-container matColumnDef="createdAt">
        <th mat-header-cell *matHeaderCellDef> Data utworzenia </th>
        <td mat-cell *matCellDef="let element">
          {{element.createdAt | date:'y-MM-dd HH:mm'}}
        </td>
      </ng-container>

      <ng-container matColumnDef="createdBy">
        <th mat-header-cell *matHeaderCellDef> Użytkownik </th>
        <td mat-cell *matCellDef="let element">
          <ng-container *ngIf="element.createdBy">
            <a class="default-link" [routerLink]="['/uzytkownicy/szczegoly', element.createdBy.uuid]">{{element.createdBy?.firstName}} {{element.createdBy?.lastName}}</a>
          </ng-container>
          <ng-container *ngIf="!element.createdBy">
            System
          </ng-container>
        </td>
      </ng-container>

      <ng-container matColumnDef="ofwca">
        <th mat-header-cell *matHeaderCellDef> OFWCA </th>
        <td mat-cell *matCellDef="let element">
          <ng-container *ngIf="element.ofwca">
            <a class="default-link" [routerLink]="['/ofwca/szczegoly', element.ofwca?.uuid]">{{element.ofwca?.fullName}}</a>
          </ng-container>
        </td>
      </ng-container>


      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef> Status </th>
        <td mat-cell *matCellDef="let element">
          <button *ngIf="element.status" mat-raised-button [ngClass]="element.status.color + '-button'">
            {{element.status.name}}
          </button>
        </td>
      </ng-container>

      <ng-container matColumnDef="action">
        <th mat-header-cell *matHeaderCellDef>  </th>
        <td mat-cell *matCellDef="let element">
                    <button *ngIf="(userPermissions | async).hiperio?.write && element.status.key === HIPERIO_TEST_ACCESS_FORM_STATUS_PENDING" (click)="changeStatus(element.uuid, HIPERIO_TEST_ACCESS_FORM_STATUS_ACCEPTED)" mat-button color="accent"><mat-icon>check</mat-icon></button>
                    <button *ngIf="(userPermissions | async).hiperio?.write && element.status.key === HIPERIO_TEST_ACCESS_FORM_STATUS_PENDING" (click)="changeStatus(element.uuid, HIPERIO_TEST_ACCESS_FORM_STATUS_REJECTION)" mat-button  color="warn"><mat-icon>close</mat-icon></button>

        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>

    <mat-paginator [pageSizeOptions]="[10, 20, 50,]" [length]="totalData"></mat-paginator>
  </div>
